module.exports = __webpack_public_path__ + "img/image25.2beb1546.jpeg";